/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// Logica invertida (pull-up): a diferencia del ARDUINOUNO_ENTRADAS_button
// generico, este devuelve !digitalRead.
export const ARDUINOUNO_ENTRADAS_button_TREN = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_button_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`!digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

const installTrenMotorSerial = (generator) => {
  generator.definitions_.declare_var = '#include <SoftwareSerial.h>\nSoftwareSerial BTserial(2, 3);\n';
  generator.setups_.motor_dc_ = 'BTserial.begin(9600);';
};

// Diverge del legacy a propósito: el legacy emitía C++ inválido acá (";" tras
// la firma y llave faltante antes del else). Se mantiene la misma intención.
export const ARDUINOUNO_SALIDAS_motor_tren_avanzar = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  installTrenMotorSerial(generator);
  generator.definitions_.avanzar = `
void avanzarElTren(int direccionRetiroPilar) {
  if (direccionRetiroPilar == 0) {
    BTserial.write('1');
  } else {
    BTserial.write('2');
  }
}
`;
  return `avanzarElTren(${pin});\n`;
};

export const ARDUINOUNO_SALIDAS_motor_tren_frenar = (block, generator) => {
  installTrenMotorSerial(generator);
  generator.definitions_.frenar = `
void frenarElTren() {
  BTserial.write('3');
}
`;
  return 'frenarElTren();\n';
};

// Usa siempre loop_, como el dht11 genérico, aunque el legacy alternaba
// setups_/loop_ según si el bloque colgaba de "Start".
export const ARDUINOUNO_SALIDAS_read_dht11_tren = (block, generator) => {
  const pin = 12;
  const type = block.getFieldValue('TYPE');

  generator.definitions_.define_SALIDAS_dht11 = '#include <dht11.h>\n';
  generator.definitions_[`define_SALIDAS_dht11_${pin}`] = `dht11 DHT11${pin};\n#define DHT11PIN${pin} ${pin}\n\n`;
  generator.loop_[`dht11_${pin}`] = `DHT11${pin}.read(DHT11PIN${pin});`;

  const code = type === 'T' ? `DHT11${pin}.temperature` : `DHT11${pin}.humidity`;
  return [code, generator.ORDER_ATOMIC];
};

// Objeto "lcd" en 0x27 fijo y lcd.clear() en el setup: difiere a propósito del
// ARDUINOUNO_lcd_educabot genérico.
export const ARDUINOUNO_lcd_educabot_tren = (block, generator) => {
  const cursCol = block.getFieldValue('CURSOR_COLUMN');
  const cursRow = block.getFieldValue('CURSOR_ROW');
  const output = generator.valueToCode(block, 'NAME', generator.ORDER_ATOMIC) || '';

  generator.definitions_.declare_lcd = `
#include <Wire.h>
#include <LiquidCrystal_I2C.h>

LiquidCrystal_I2C lcd(0x27, 16, 2);
`;
  generator.setups_.setup_lcd_ = `
  lcd.init();
  lcd.backlight();
  lcd.clear();
`;

  return `
  lcd.setCursor(${cursCol}, ${cursRow});
  lcd.print(${output});
`;
};

export const ARDUINOUNO_salidas_led_tren = (block, generator) => {
  const state = block.getFieldValue('STAT');
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_green_led_${pin}`] = `pinMode(${pin}, OUTPUT);\n`;
  return `digitalWrite(${pin}, ${state});\n`;
};

export const ARDUINOUNO_servo_move_tren = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);

  generator.definitions_.include_servo = '#include <Servo.h>\n\n';
  generator.definitions_.include_servo_ = 'Servo servo_1;\nServo servo_2;\n';
  generator.setups_.servo_move_ = 'servo_1.attach(8);\nservo_2.attach(9);\n';

  return `servo_1.write(${angle});\nservo_2.write(${angle});\n`;
};

export const slider_angle_tren = (block, generator) => {
  const code = block.getFieldValue('angulo');
  return [code, generator.ORDER_ATOMIC];
};
